import dayjs from "dayjs";

const TimeType = Symbol();

export class Time {
    [TimeType]: any;
    readonly hour: number;
    readonly minute: number;
    readonly second: number;

    private constructor(hour: number, minute: number, second: number) {
        this.hour = hour;
        this.minute = minute;
        this.second = second;
    }

    format(): string {
        return `${this.hour.toString().padStart(2, "0")}:${this.minute.toString().padStart(2, "0")}:${this.second.toString().padStart(2, "0")}`;
    }

    formatHourMinute(): string {
        return `${this.hour.toString().padStart(2, "0")}:${this.minute.toString().padStart(2, "0")}`;
    }

    getMinuteDuration = (): number => {
        // 00:00からの経過した分を取得する
        return this.hour * 60 + this.minute;
    };

    static fromString(timeString: string): Time {
        assertFormat(timeString);
        return new Time(
            Number(timeString.substr(0, 2)),
            Number(timeString.substr(3, 2)),
            Number(timeString.substr(6, 2))
        );
    }

    static fromNumber(hour: number, minute: number, second: number): Time {
        return new Time(
            hour,
            minute,
            second
        );
    }

    static fromNothing(): Time {
        return new Time(0, 0, 0);
    }

    static isTimeFormat = (str: string): boolean => {
        // hh:mm:ssの形式をチェック
        if (! /\d{2}:\d{2}:\d{2}/.test(str)) return false;
        // 0-24
        const hour = Number(str.substr(0, 2));
        if (hour < 0 || 24 < hour) return false;
        // 0-59
        const minute = Number(str.substr(3, 2));
        if (minute < 0 || 59 < minute) return false;
        // 0-59
        const second = Number(str.substr(6, 2));
        if (second < 0 || 59 < second) return false;
        return true;
    };

    static now(): Time {
        return Time.fromDayJs(dayjs());
    }

    private static fromDayJs(dayjs: dayjs.Dayjs) {
        return Time.fromString(dayjs.format("HH:mm:ss"));
    }
}

class InvalidYearMonthFormatError extends Error {}

const assertFormat = (str: string) => {
    if (!Time.isTimeFormat(str)) {
        throw new InvalidYearMonthFormatError("time must be format with 'hh:mm:ss'");
    }
};
